export default __webpack_public_path__ + "static/corporate-training_barcelona-code-school-jikken-kobo-a0db4c30a5c5b91952790ac0d234904c.png";